// Map chapter: the portfolio-size segmented control drives the constellation's
// density, and a ticker counts today's movement.
import { pointCount } from './constellation'
import { $, $$, G, ST, fmt, motion } from './misc'

export function wireMap(animated: boolean): void {
  const sec = $('#mapa')
  if (!sec) return
  const btns = $$('.seg button', sec); const per = $('.per', sec); const tks = $$('[data-tk]', sec)
  if (!per || tks.length < 3) return
  const N = motion.gl?.N ?? pointCount()
  const LV = [
    { n: 300, per: 'Cada punto es una póliza.', base: [1, 14, 1] },
    { n: Math.min(N, 2700), per: 'Cada punto representa 3 pólizas.', base: [34, 610, 9] },
    { n: N, per: `Cada punto representa unas ${Math.round(300000 / N)} pólizas.`, base: [1250, 22800, 310] },
  ]
  const counts = [1250, 22800, 310]
  let level = 2; let auto: number[] = []; let tick = 0
  const set = (L: number, user = false) => {
    if (user) { auto.forEach(clearTimeout); auto = [] }
    level = L
    btns.forEach((b) => b.setAttribute('aria-pressed', String(Number(b.dataset.level) === L)))
    per.textContent = LV[L].per
    motion.gl?.setMapCount(LV[L].n)
    LV[L].base.forEach((v, k) => {
      if (!animated) { counts[k] = v; tks[k].textContent = fmt(v); return }
      const o = { v: counts[k] }
      G.to(o, { v, duration: 1.2, ease: 'power3.out', onUpdate: () => { counts[k] = o.v; tks[k].textContent = fmt(o.v) } })
    })
  }
  btns.forEach((b) => b.addEventListener('click', () => set(Number(b.dataset.level), true)))
  per.textContent = LV[2].per
  if (!animated) return
  const startTick = () => {
    clearInterval(tick)
    tick = window.setInterval(() => {
      const k = Math.random() < 0.55 ? 1 : Math.random() < 0.6 ? 0 : 2
      counts[k] += k === 1 ? 1 + Math.floor(Math.random() * (level + 1) * 3) : 1
      tks[k].textContent = fmt(counts[k])
    }, 420)
  }
  ST.create({
    trigger: sec, start: 'top 55%', end: 'bottom 30%',
    onEnter: () => { set(0); auto = [window.setTimeout(() => set(1), 2200), window.setTimeout(() => set(2), 4400)]; startTick() },
    onLeave: () => clearInterval(tick),
    onEnterBack: startTick,
    onLeaveBack: () => { clearInterval(tick); auto.forEach(clearTimeout) },
  })
}
